import { IEvent } from "../models/IEvent";
import { IUser } from "../models/IUser";
import { IOrganizer } from "../models/IOrganizer";
import { axiosInstance } from "./ServiceConstants";
import axios, { CancelToken } from "axios";

class UserAdminService {
    
    async getEvents(organizerId: string, from?: Date, to?: Date, cancelToken?: CancelToken): Promise<IEvent[]> {
        try {
            const params = new URLSearchParams();
            if (from) {
                params.append("from", from.toISOString());
            }
            if (to) {
                params.append("to", to.toISOString());
            }
            const queryString = params.toString().length > 0 ? `?${params.toString()}` : "";
            const url = `api/organizer/${organizerId}/events${queryString}`;
            let eventsResponse = await axiosInstance.get<IEvent[]>(url, { cancelToken });
            return eventsResponse.data;
        } catch (e) {
            if (axios.isCancel(e)) {
                throw e;
            }
            console.error(e);
            return [];
        }
    }
    async getOrganizers(nocache?: boolean, cancelToken?: CancelToken): Promise<IOrganizer[]> {
        const url = nocache ? 'api/organizer?nocache' : 'api/organizer?popular=true';
        let organizerResponse = await axiosInstance.get<IOrganizer[]>(url, { cancelToken });
        return organizerResponse.data;
    }

    async searchOrganizers(organizerSearchTerm: string): Promise<IOrganizer[]>{
        let organizerResponse = await axiosInstance.get<IOrganizer[]>(`api/organizer/search?term=${organizerSearchTerm}`);
        return organizerResponse.data;
    }
    async getOrganizer(organizerId: string, cancelToken?: CancelToken): Promise<IOrganizer> {
        let organizerResponse = await axiosInstance.get<IOrganizer>(`api/organizer/${organizerId}`, { cancelToken });
        return organizerResponse.data;
    }

    async searchUsers(term: string) : Promise<IUser[]> {
        let requestData = new FormData();
        requestData.append("term", term);
        let organizerResponse = await axiosInstance.post<IUser[]>('api/user/search', requestData);
        return organizerResponse.data;
    }
    async removeOrganizerRole(userId: string): Promise<void> {
        await this.removeUserRole(userId, "organizer");
    }
    async assignOrganizerRole(userId: string): Promise<void> {
        await this.assignUserRole(userId, "organizer");
    }
    async removeUserRole(userId: string, roleName: string): Promise<void> {
        await axiosInstance.delete(`api/organizer/${userId}/role`, { data: { roleName } });
    }
    async assignUserRole(userId: string, roleName: string): Promise<void> {
        await axiosInstance.post(`api/organizer/${userId}/role`, { roleName });
    }
    async getRoles(): Promise<string[]> {
        const response = await axiosInstance.get<string[]>("api/organizer/roles");
        return response.data;
    }

    async getUser(userId: string): Promise<IUser> {
        const response = await axiosInstance.get<IUser>(`api/User/admin/${userId}`);
        return response.data;
    }

    async resetPassword(userId: string, newPassword?: string): Promise<{ generatedPassword?: string }> {
        const body = newPassword ? { newPassword } : {};
        const response = await axiosInstance.post<{ generatedPassword?: string }>(`api/user/${userId}/resetPassword`, body);
        return response.data;
    }

    async updateUser(userId: string, userData: Partial<IUser>): Promise<IUser> {
        const response = await axiosInstance.put<IUser>(`api/user/${userId}`, userData);
        return response.data;
    }

    async updateEmail(userId: string, newEmail: string): Promise<void> {
        await axiosInstance.post(`api/user/${userId}/updateEmail`, { newEmail });
    }
}

const UserAdminServiceInstance = new UserAdminService();

export default UserAdminServiceInstance;